import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {reExportedColors, DeleteIconButton, Text} from '../../1elements'
import IconButton from '@mui/material/IconButton'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import makeStyles from '@material-ui/core/styles/makeStyles'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'

const useStyles = makeStyles({
    root: {

    },
    serviceTypeNameRow: {
        maxHeight: '50px',
        '& p': {
            margin: 'auto auto auto 0'
        }
    },
    list: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    },
    listItem: {
        paddingLeft: '52px'
    },
    selected: {
        backgroundColor: reExportedColors.LIGHT_GREY ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    }
})

const ServiceTypeAccordion = (
    {
        disabled, serviceTypeName, selectServiceType, serviceList, deleteService, setInput, selectedServiceType,
        setSelectedServiceTypeId
    }
) => {
    const classes = useStyles()

    const isSelected = () => {
        if(selectedServiceType === serviceTypeName['service_type']) return classes.selected
    }

    const onAddClick = (event, serviceTypeName) => {
        selectServiceType(serviceTypeName['service_type'])
        setSelectedServiceTypeId(serviceTypeName['service_type_id'])
        event.stopPropagation()
    }

    return(
        <Accordion className={classes.root} defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}
                              className={`${classes.serviceTypeNameRow} ${isSelected()}`}>
                <Text type={'serviceTypeName'}>{serviceTypeName['service_type']}</Text>
                {!disabled && (
                    <IconButton onClick={(event)=> onAddClick(event, serviceTypeName)} disabled={disabled}>
                        <AddCircleOutlineIcon />
                    </IconButton>
                )}
            </AccordionSummary>
            <AccordionDetails>
                <List className={classes.list}>
                    {serviceList && serviceList.map((service, index)=>(
                        <ListItem
                            key={index}
                            disablePadding
                            secondaryAction={
                                !disabled && (
                                    <DeleteIconButton
                                        onClick={()=>deleteService(serviceTypeName['service_type'], index)} fontSize={'small'} />
                                )
                            }
                        >
                            <ListItemButton
                                onClick={()=>setInput(serviceTypeName['service_type'], index)}
                                className={classes.listItem}
                            >
                                <ListItemText primary={service.serviceName ? service.serviceName : service.name} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                    {
                        (!serviceList || serviceList.length === 0) &&
                            <div className={classes.listItem}>
                                <Text type={'noService'}>No Service</Text>
                            </div>
                    }
                </List>
            </AccordionDetails>
        </Accordion>
    )
}

export default ServiceTypeAccordion
